<template>
  <div>
    <a-card title="Subscriptions" class="style1">
      <table class="table">
        <thead>
          <tr>
            <th>{{ $t('label.plan') }}</th>
            <th>{{ $t('label.price') }}</th>
            <th>{{ $t('label.nextBillingDate') }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(subscription, index) in subscriptions" :key="index">
            <td>{{ subscription.plan.name }}</td>
            <td>{{ subscription.currency }} {{ Number(subscription.unit_amount_in_cents / 100).toFixed(2) }}</td>
            <td>{{ formatDate(subscription.current_term_ends_at) }}</td>
          </tr>
        </tbody>
      </table>
    </a-card>
  </div>
</template>
<script>
import UserService from '@/services/UserService';
import moment from 'moment';
export default {
  data: () => ({
    subscriptions: [],
  }),
  async created() {
    const respSubscription = await UserService.getSubscriptionDetails();
    this.subscriptions = respSubscription;
  },
  methods: {
    formatDate(date) {
      return moment(date).add(12, 'M').format('MM/DD/YYYY');
    },
  },
};
</script>
